import { Box, Typography, Rating } from '@mui/material';

export function RatingTypography({ reviews, rating, onChange, editable = false, page = false }) {
  return (
    <Box display="flex" alignItems="center" gap={0.5}>
      <Rating
        value={typeof rating === 'number' ? rating : 0}
        precision={0.5}
        readOnly={!editable}
        onChange={(e, val) => onChange?.(val)}
      />
      <Typography variant="body2">
        {(typeof rating === 'number' ? rating.toFixed(1) : '0.0')}
        {!editable && page ? ` (${reviews})` : null}
      </Typography>
    </Box>
  );
}
